import { ToNumber } from "#packages/ecma262-abstract/ToNumber.js";
import { DayFromYear, DaysInYear } from "#packages/ecma262-abstract/DateOperations.js";
// Intrinsic calls check internal slots across realms without reading user properties.
// https://tc39.es/proposal-temporal/#sec-temporal-istemporalobject
const temporal = globalThis.Temporal;
const readers = temporal ? [
	"PlainDate",
	"PlainYearMonth",
	"PlainMonthDay",
	"PlainTime",
	"PlainDateTime",
	"Instant",
	"ZonedDateTime"
].map((kind) => ({
	kind,
	read: kind === "Instant" || kind === "ZonedDateTime" ? Object.getOwnPropertyDescriptor(temporal[kind].prototype, "epochNanoseconds").get : Object.getOwnPropertyDescriptor(temporal[kind].prototype, "toString").value
})) : [];
const stringOptions = Object.assign(Object.create(null), { calendarName: "always" });
const CALENDAR_ANNOTATION = /\[u-ca=([^\]]+)\]/;
const ISO_DATE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})/;
const ISO_TIME = /(?:^|T)(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?/;
const dateGetTime = Date.prototype.getTime;
const monthStarts = [
	0,
	31,
	59,
	90,
	120,
	151,
	181,
	212,
	243,
	273,
	304,
	334
];
export function ToDateTimeFormattable(value) {
	if (value !== null && typeof value === "object" && readers.length) {
		let isDate = false;
		try {
			dateGetTime.call(value);
			isDate = true;
		} catch {}
		if (isDate) return ToNumber(value);
		for (const { kind, read } of readers) {
			let result;
			try {
				result = read.call(value, stringOptions);
			} catch {
				continue;
			}
			if (kind === "Instant" || kind === "ZonedDateTime") {
				return {
					kind,
					epochNanoseconds: BigInt(result)
				};
			}
			// calendarName=always includes the ISO reference date for YearMonth/MonthDay.
			// Parsing this intrinsic result avoids Date's TimeClip and user-defined coercion.
			const text = String(result);
			const calendar = CALENDAR_ANNOTATION.exec(text)?.[1];
			const date = ISO_DATE.exec(text);
			const time = ISO_TIME.exec(text);
			let epochNanoseconds = BigInt(0);
			if (date) {
				const year = Number(date[1]);
				const month = Number(date[2]);
				const days = DayFromYear(year) + monthStarts[month - 1] + Number(date[3]) - 1 + (month > 2 && DaysInYear(year) === 366 ? 1 : 0);
				epochNanoseconds = BigInt(days) * BigInt(864e11);
			}
			if (time) {
				epochNanoseconds += BigInt(Number(time[1]) * 3600 + Number(time[2]) * 60 + Number(time[3])) * BigInt(1e9) + BigInt(((time[4] || "") + "000000000").slice(0, 9));
			} else {
				epochNanoseconds += BigInt(432e11);
			}
			return {
				kind,
				calendar,
				epochNanoseconds
			};
		}
	}
	return ToNumber(value);
}
